import React from 'react';
import style from './style.module.scss';
import {Tooltip} from 'components/Tooltip';
import Link from 'components/CustomRoutingLink';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {PRODUCT_ART_LINK} from 'components/ProductSnippet/ProductSnippet.constants';
import cs from 'classnames';
import {Typography} from 'components/Typography';

type TARTProps = Pick<IProductSnippet, 'id'> & {className?: string; place?: 'bottom-start' | 'bottom'};

export const ART = (props: TARTProps) => {
    const {id, className = '', place = 'bottom'} = props;

    return (
        <Tooltip
            childrenClassName={cs(style.tooltip, className)}
            id={id.toString() + '/art'}
            place={place}
            overlay={
                <div className={style.overlay}>
                    <Typography variant={'label-12-r'}>
                        Находится в нашей специальной коллекции <Link href={PRODUCT_ART_LINK}>Simple A.R.T.</Link>
                    </Typography>
                </div>
            }
        >
            <Typography variant={'label-12-m'} className={style.title}>
                A.R.T.
            </Typography>
        </Tooltip>
    );
};
